var paymentStatuses = [
    {"name": "پرداخت نشده", id: 0},
    {"name": "پرداخت شده", id: 1},
];

export default paymentStatuses;